// eslint-disable-next-line import/no-cycle
import contragent from './contragent';
import inspection from './inspection';
import auditor from './auditor';
import zvt from './zvt';

const cats = {
  contragent,
  inspection,
  auditor,
  zvt,
};

export default cats;
